import { useState } from 'react';
import CustomWatchlistReportService, { CustomReportAlumniRow } from './CustomWatchlistReportService';
import { Overlay, useSave } from './ReportOverlay';
import { REMOVE_REASONS } from './customStage';

const RemoveMemberModal = ({
    row,
    watchlistId,
    watchlistName,
    instituteId,
    filterInstituteId,
    onClose,
    onDone,
}: {
    row: CustomReportAlumniRow;
    watchlistId: string | number;
    watchlistName?: string | null;
    instituteId: string | number;
    filterInstituteId?: string | null;
    onClose: () => void;
    onDone: () => void;
}) => {
    const [reason, setReason] = useState('');
    const { saving, error, run } = useSave(
        () => CustomWatchlistReportService.removeMemberWithReason(
            watchlistId,
            row.student_id,
            { reason },
            { institute_id: instituteId, filter_institute_id: filterInstituteId },
        ),
        onDone,
    );

    return (
        <Overlay
            title="Remove from Watchlist"
            onClose={onClose}
            footer={
                <>
                    <button className="btn btn-outline-secondary px-4 rounded-3" onClick={onClose} disabled={saving}>Cancel</button>
                    <button className="btn btn-danger px-4 rounded-3" onClick={run} disabled={saving || !reason}>
                        {saving ? 'Removing…' : 'Confirm remove'}
                    </button>
                </>
            }>
            {error && <div className="alert alert-danger font-12">{error}</div>}
            <p className="font-13 mb-3">
                Remove <span className="font-600">{row.name ?? 'this alumni'}</span>
                {watchlistName ? <> from <span className="font-600">{watchlistName}</span></> : null}? This cannot be undone.
            </p>
            <label className="form-label text-muted font-12 font-600">Reason</label>
            <select className="form-select rounded-3 font-14" value={reason} onChange={(e) => setReason(e.target.value)}>
                <option value="">Select a reason…</option>
                {REMOVE_REASONS.map((r) => (
                    <option key={r} value={r}>{r}</option>
                ))}
            </select>
        </Overlay>
    );
};

export default RemoveMemberModal;
